module.exports = __webpack_public_path__ + "static/explore_screen-372ab12e8ed10afdd4a437f7197c817a.png";